import { Step } from "@storebrand-digital/insurance-stepper";
import { convertToURI } from "Constants/constants";
import { isDefined } from "Utils/functions";

export const defaultStep: Step = {
  id: "0",
  title: "defaultStep",
  ariaLabel: "defaultStep",
  complete: false,
};

export const findStep = (
  steps: Step[],
  id: string | undefined,
): Step | undefined => {
  return steps.find((step) => step.id === id);
};

export const findNextStep = (
  steps: Step[],
  stepId?: string,
): Step | undefined => {
  const stepIndex = findStepIndex(steps, stepId);
  if (isDefined(stepIndex >= 0) && !isLastStep(steps, stepId)) {
    return steps[stepIndex + 1];
  }
};

export const findPreviousStep = (
  steps: Step[],
  stepId?: string,
): Step | undefined => {
  const stepIndex = findStepIndex(steps, stepId);
  if (isDefined(stepIndex >= 0) && !isFirstStep(steps, stepId)) {
    return steps[stepIndex - 1];
  }
};

export const getPrecedingSteps = (steps: Step[], stepId?: string): Step[] => {
  return steps.slice(0, findStepIndex(steps, stepId));
};

export const getSubsequentSteps = (steps: Step[], stepId?: string): Step[] => {
  return steps.slice(findStepIndex(steps, stepId) + 1);
};

export const findStepIndex = (steps: Step[], stepId?: string): number => {
  return steps.findIndex((step) => step.id === stepId);
};

export const isFirstStep = (steps: Step[], stepId?: string): boolean => {
  const index = findStepIndex(steps, stepId);
  return index === 0;
};

export const isLastStep = (steps: Step[], stepId?: string): boolean => {
  const index = findStepIndex(steps, stepId);
  return index !== -1 && index === steps.length - 1;
};

export const createStepUri = (
  stepId: string,
  path: string | undefined,
): string | undefined =>
  isDefined(path) ? `${path}/${convertToURI(stepId)}` : undefined;

export const withStepUri = (step: Step, path: string | undefined): Step => ({
  ...step,
  uri: step.uri ?? createStepUri(step.id, path),
});
